import FlexOfficeHero from "./components/FlexOfficeHero";
import FlexOfficeProblemSolution from "./components/FlexOfficeProblemSolution";
import FlexOfficeFeatures from "./components/FlexOfficeFeatures";
import FlexOfficeHowItWorks from "./components/FlexOfficeHowItWorks";
import FlexOfficePricing from "./components/FlexOfficePricing";
import FlexOfficeCTA from "./components/FlexOfficeCTA";

const FlexOfficeKrumagoMain = () => {
  return (
    <div style={{ fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif" }}>
      <FlexOfficeHero />
      <FlexOfficeProblemSolution />
      <FlexOfficeFeatures />
      <FlexOfficeHowItWorks />
      <FlexOfficePricing />
      <FlexOfficeCTA />
    </div>
  );
};

export default FlexOfficeKrumagoMain;